"use client"

import { motion } from "framer-motion"
import { Menu, Plus } from "lucide-react"

interface MobileFloatingMenuProps {
  onOpenSidebar: () => void
  onNewChat: () => void
}

export function MobileFloatingMenu({
  onOpenSidebar,
  onNewChat,
}: MobileFloatingMenuProps) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className="fixed left-2 top-2 z-40 flex items-center gap-1.5 p-1.5 bg-[rgba(232,226,255,0.5)] rounded-2xl shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[10px] border border-[rgba(232,226,255,0.7)]"
      style={{
        WebkitBackdropFilter: 'blur(10px)',
      }}
    >
      {/* Menu Button */}
      <button
        onClick={onOpenSidebar}
        className="p-2 hover:bg-white/20 rounded-xl transition-all duration-200 group"
        aria-label="Open menu"
      >
        <Menu className="w-4 h-4 text-gray-700 group-hover:text-gray-900 transition-colors" />
      </button>

      {/* New Chat Button */}
      <button
        onClick={onNewChat}
        className="p-2 hover:bg-white/20 rounded-xl transition-all duration-200 group"
        aria-label="New chat"
      >
        <Plus className="w-4 h-4 text-gray-700 group-hover:text-primary-600 group-hover:rotate-90 transition-all duration-300" />
      </button>
    </motion.div>
  )
}
